// /prefer DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정.

import React from "react";
import { Link } from "react-router-dom";
import { EditButton } from "@refinedev/mui";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { OverflowTooltip } from "components/list";
import { IPrefer } from "../interfaces";

const linkStyle: React.CSSProperties = {
  textDecoration: "underline",
  fontWeight: 600,
  color: "var(--color-primary)",
};

export const preferColumns: GridColDef<IPrefer>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "parentId",
    headerName: "학부모ID",
    type: "string",
    width: 120,
    minWidth: 100,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.value}>
        <Link to={`/parents/show/${params.value}`} style={linkStyle}>
          {params.value}
        </Link>
      </OverflowTooltip>
    ),
  },
  {
    field: "centerId",
    headerName: "시설ID",
    type: "string",
    width: 120,
    minWidth: 100,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.value}>
        <Link to={`/centers/show/${params.value}`} style={linkStyle}>
          {params.value}
        </Link>
      </OverflowTooltip>
    ),
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 90,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <EditButton hideText recordItemId={params.row.id} />
    ),
  },
];
